let headerStyleTrack = {};

// Navigation toggle
window.addEventListener('load', function () {
  const loggedIn = document.body.classList.contains('logged-in');

  //animation footer badge
  const footerBadge = document.querySelector('.footer-badge')

  setTimeout(() => {
    footerBadge.style.transform = 'rotate(0deg)'
  }, "0")

  footerBadge.addEventListener("transitionend", (event) => {
    if(event.target.attributes.style.nodeValue === "transform: rotate(0deg);") {
      setTimeout(() => {
        footerBadge.style.transform = 'rotate(45deg)'
      }, "900")
    } else {
      setTimeout(() => {
        footerBadge.style.transform = 'rotate(0deg)'
      }, "900")
    }
  });

  const header = document.querySelector('header');
  const menu = document.getElementById('side-menu');
  const menuToggle = document.querySelector('.menu-toggle');
  const body = document.querySelector('body');
  
  menuToggle.addEventListener('click', () => {
    header.classList.toggle('active');
    menu.classList.toggle('active');
    menuToggle.classList.toggle('active');
    body.classList.toggle('overflow-hidden');
  });

  const primaryMenu = document.getElementById('primary-menu');
  const primaryMenuItems = primaryMenu.querySelectorAll('a');
  
  const sideImages = document.querySelectorAll('.side-images > img');

  primaryMenuItems.forEach((item, index) => {
    item.addEventListener('mouseenter', () => {
      sideImages[0].classList.remove('active');
      sideImages[index+1]?.classList.add('active');
    });

    item.addEventListener('mouseleave', () => {
      sideImages[0].classList.add('active');
      sideImages[index+1]?.classList.remove('active');
    });
  });

  const updateHeaderStyleTrack = () => {
    const headerModifierSections = document.querySelectorAll('*[data-header-style]');

    headerModifierSections.forEach((sectionElm) => {
      const rect = sectionElm.getBoundingClientRect();
      const section = {
        top: Math.round(rect.top) + Math.round(window.pageYOffset) - (loggedIn ? 32 : 0),
        height: Math.round(rect.height)
      };

      const sectionStyle = sectionElm.getAttribute('data-header-style');
      const height = headerStyleTrack[section.top] ? section.top + 1 : section.top;
      headerStyleTrack[height] = sectionStyle;

      for(let i = section.top; i < section.top + section.height; i++) {
        headerStyleTrack[i] = sectionStyle;
      }
    });
  };

  const setHeaderStyleFromScroll = (scroll) => {
    scroll = Math.round(scroll);
    
    header.setAttribute('data-theme', headerStyleTrack[scroll] || 'light')
  };

  const windowScroll = () => {
    setHeaderStyleFromScroll(window.scrollY);
  };
  updateHeaderStyleTrack();
  window.addEventListener('scroll', windowScroll);
  setInterval(updateHeaderStyleTrack, 500);
  windowScroll();
});
